// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.19.0';
//# sourceMappingURL=version.js.map